var moment = require('moment');
var locales = {
    de : require('moment/locale/de'),
    fr : require('moment/locale/fr'),
    it : require('moment/locale/it'),
    nl : require('moment/locale/nl'),
    ru : require('moment/locale/ru'),
    en : require('moment/locale/en-gb')
};

(function localeMoment() {
    const currentLang = document.documentElement.getAttribute('lang');
    const targetLocale = locales[currentLang] || locales.en;

    moment.locale(currentLang, targetLocale);
}());


// Generate the i18n data, don't use the moment internal localeData() for this, since some localizations are incompatible and need arguments for the methods.
function getMonths() {
    var months = [];

    for (var i = 0; i < 12; i++) {
        var month = moment.localeData().months({
            month: function() {
                return i;
            }
        }, 'none');

        months.push(month);
    }

    return months;
}
function getWeekDays() {
    var days = [];

    for (var i = 0; i < 7; i++) {
        var day = moment.localeData().weekdays({
            day: function() {
                return i;
            }
        }, 'none');

        days.push(day);
    }

    return days;
}
function getWeekDaysShort() {
    var localeData = moment.localeData();
    var days = localeData._weekdaysShort;

    if(!days) {
        console.error('Datepicker moment error: No weekDaysShort where found in the current localization.', localeData);
    }

    return days;
}

module.exports = {
    moment: moment,
    getMonths: getMonths,
    getWeekDays: getWeekDays,
    getWeekDaysShort: getWeekDaysShort
};